import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

import DeleteModalDialog from './DeleteModalDialog.react';

const StyledButton = styled(Button)(({ theme }) => {
  return {
    margin: theme.spacing(1),
  };
});

const DeleteButton = ({
  buttonLabel = 'Delete',
  promptTitle,
  promptDescription,
  deleteAction,
  uniqueId: _uniqueId = undefined,
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <StyledButton onClick={handleClickOpen}>{buttonLabel}</StyledButton>
      <DeleteModalDialog
        title={promptTitle}
        message={promptDescription}
        open={open}
        onClose={handleClose}
        onDelete={deleteAction}
      />
    </>
  );
};

DeleteButton.propTypes = {
  promptTitle: PropTypes.object.isRequired,
  promptDescription: PropTypes.object.isRequired,
  deleteAction: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
  uniqueId: PropTypes.any,
};

export default DeleteButton;
